<template>
    <div>
        <div class="divider thin uk-margin-medium-top"></div>
        <div class="employee-ratings-heading" @click="toggleTable()">
            <span class="employee-ratings-name">{{ group.skill_name }}</span>
            <span class="employee-ratings-average">Average Rating: {{ group.average_rating }}</span>
            <i class="fas fa-caret-down uk-float-right" :class="{open:showing}"></i>

        </div>
        <transition name="expand"
                    @enter="enter"
                    @after-enter="afterEnter"
                    @leave="leave">
            <div v-if="showing" class="uk-grid uk-margin-small-top uk-margin-medium-bottom">
                <div class="uk-width-1-3" v-for="placement in group.placements">
                    <div class="field">
                        <span class="label">Requisition #</span>
                        <span class="value">{{ placement.requisition_number }}</span>
                    </div>
                    <div v-if="placement.needs_detail" class="field">
                        <span class="label">Submitted By</span>
                        <span @click="showSubmissions(placement)" class="value linked">See submissions</span>
                    </div>
                    <div v-else class="field">
                        <span class="label">Submitted By</span>
                        <span class="value">{{ placement.submitter }}</span>
                    </div>
					<div v-if="!placement.needs_detail && placement.rating_requests" class="field">
						<span class="label">Submitted On</span>
						<span class="value">{{ recentDate(placement) }}</span>
					</div>
                    <div class="field" v-for="name in group.rating_names" v-if="placement.ratings[name]">
                        <span class="label">{{ name }}</span>
                        <span class="value">{{ placement.ratings[name] }}</span>
                    </div>
                    <div class="field">
                        <span class="label">Average</span>
                        <span class="value">{{ placement.average_rating }}</span>
                    </div>
                </div>
            </div>
        </transition>
        <div class="divider thin uk-margin-small-top"></div>
        <div ref="allRatings" :id="modalId" uk-modal>
            <div v-if="modalPlacement" class="uk-modal-dialog uk-modal-dialog-wide uk-modal-body employee-ratings">
                <div class="uk-grid uk-margin-small-top uk-margin-medium-bottom">
                    <div class="uk-width-1-3" v-for="request in modalPlacement.rating_requests">
                        <div class="field">
                            <span class="label">Submitted By</span>
                            <a :href="request.url" target="_blank" class="value">{{ request.submitter }}</a>
                        </div>
						<div v-if="request.completed_at" class="field">
                            <span class="label">Submitted On</span>
                            <span class="value">{{ fDate(request.completed_at) }}</span>
                        </div>
                        <div class="field" v-for="(rating, index) in request.ratings">
                            <span class="label">{{ index }}</span>
                            <span class="value">{{ rating.rating }} <span class="delete-rating" @click="dropRating(rating.id)">X</span></span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Format from "../Classes/Format";

	export default {
        name: "EmployeePlacementDataSection",

        props: ["group"],

        components: {},

        data() {
            return {
                showing: false,
                modalId: "grp",
                modalPlacement: null
            };
        },

        mounted() {
            this.modalId = "grp_" + this.group.id;
        },

        methods: {
            enter(element) {
                const width = getComputedStyle(element).width;

                element.style.width = width;
                element.style.position = 'absolute';
                element.style.visibility = 'hidden';
                element.style.height = 'auto';

                const height = getComputedStyle(element).height;

                element.style.width = null;
                element.style.position = null;
                element.style.visibility = null;
                element.style.height = 0;
                getComputedStyle(element).height;
                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
            leave(element) {
                const height = getComputedStyle(element).height;

                element.style.height = height;
                getComputedStyle(element).height;

                setTimeout(() => {
                    element.style.height = 0;
                });
            },
            toggleTable(){
                this.showing = !this.showing;
            },
            showSubmissions(placement){
                this.modalPlacement = placement;
                UIkit.modal(this.$refs.allRatings).show();
            },
			fDate(dt){
				return Format.formatDate(dt);
			},
			recentDate(placement){
				for(name in placement.rating_requests){
					let request = placement.rating_requests[name];
					if(request.completed_at){
						return Format.formatDate(request.completed_at);
					}
				}
				return "";
			},
            dropRating(id){
                UIkit.modal.confirm("Are you sure you want to delete this rating?").then(() => {
                    axios.post("/api/rating/delete/" + id).then(
                        () => {
                            this.$emit("updateRatings");
                        },
                        () => {}
                    )
                },
                () => {
                    //console.log("nevermind");
                });
            }
        }
    }
</script>
